export const toArrayLiteral = (arr) =>
    JSON.stringify(arr || [])
        .replace('[', '{')
        .replace(']', '}');
